import React from 'react';
import webserviceModel from './model/webserviceModel';
import { SelectBasePrototype } from 'clad';

export const SelectWebserviceType = React.forwardRef((props, ref) => {
    const { data, value, onChange, mode, placeholder } = props;
    const handleFetch = () => webserviceModel.listWebserviceType();

    return (
        <SelectBasePrototype
            mode={mode}
            placeholder={placeholder || _('Select a webservice type')}
            schema={{ idOption: 'id', option: 'name' }}
            fetch={handleFetch}
            onChange={onChange}
            value={value}
            data={data}
        />
    );
});
